import React from 'react';

interface RenderTextWithLinksOptions {
  navigate?: (path: string) => void;
}

export const renderTextWithLinks = (text: string, options?: RenderTextWithLinksOptions): React.ReactNode => {
  if (!text) return text;

  const urlRegex = /(https?:\/\/[^\s)]+|localhost:[^\s)]+|www\.[^\s)]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s)*]*)/g;
  
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;

  while ((match = urlRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const url = match[0];
    
    if (options?.navigate) {
      let path = '/';
      
      if (url.includes('localhost')) {
        const parts = url.split('localhost')[1];
        if (parts && parts.includes('/')) {
          path = parts.substring(parts.indexOf('/'));
        }
      } else {
        try {
          const urlObj = new URL(url.startsWith('http') ? url : `https://${url}`);
          path = urlObj.pathname;
        } catch {
          const segments = url.split('/');
          const pathIndex = segments.findIndex(seg => seg.includes('licitacion') || seg.includes('compra-agil'));
          if (pathIndex > 0) {
            path = '/' + segments.slice(pathIndex).join('/');
          }
        }
      }
      
      parts.push(
        React.createElement('span', {
          key: match.index,
          onClick: () => options.navigate!(path),
          style: { 
            color: '#1976d2', 
            textDecoration: 'underline',
            cursor: 'pointer'
          }
        }, url)
      );
    } else {
      parts.push(
        React.createElement('span', {
          key: match.index,
          style: { 
            color: '#1976d2', 
            textDecoration: 'underline'
          }
        }, url)
      );
    }

    lastIndex = urlRegex.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  if (parts.length === 0) {
    return text;
  }

  return React.createElement(React.Fragment, {}, ...parts);
};
